import { HStack, Pressable } from '@rbilabs/universal-components';

import { getDesignToken, primitive } from 'styles/constants';
import { isWeb } from 'utils/environment';

import { BORDER_BOTTOM_VALUE } from './constants';
const listItemStyles = {
  flexGrow: 1,
  justifyContent: 'space-between',
  alignItems: 'center',
  backgroundColor: getDesignToken('background-pattern'),
  color: getDesignToken('text-default'),
  paddingY: 4,
  paddingX: 4,
};

export const ListItemContent = HStack.withConfig<{ isHeader?: boolean }>(p => ({
  ...listItemStyles,
  ...(p.isHeader && { backgroundColor: primitive.$mayoEggWhite }),
  ...(isWeb && { flex: 1 }),
  borderBottomColor: getDesignToken('border-color-default'),
  borderBottomWidth: BORDER_BOTTOM_VALUE,
}));

export const ListItemButton = Pressable.withConfig<{ isHeader?: boolean }>(p => ({
  ...listItemStyles,
  ...(p.isHeader && { backgroundColor: primitive.$mayoEggWhite }),
  flexDirection: 'row',
  borderBottomColor: getDesignToken('border-color-default'),
  borderBottomWidth: BORDER_BOTTOM_VALUE,
  flexShrink: 1,
}));

export const ProductControl = HStack.withConfig({
  alignItems: 'center',
  justifyContent: 'space-between',
  marginLeft: '$2',
});
